import { defineMessages } from 'react-intl';

export default defineMessages({
  comment: {
    id: 'bitkit.fileTree.comment',
    description: 'Text screen reader for comment icon',
    defaultMessage:
      '{count, plural, one {{count} comment} other {{count} comments}},',
  },

  linesAdded: {
    id: 'bitkit.fileTree.linesAdded',
    description: 'Text screen reader added lines',
    defaultMessage:
      '{count, plural, one {{count} line} other {{count} lines}} added,',
  },

  linesRemoved: {
    id: 'bitkit.fileTree.linesRemoved',
    description: 'Text screen reader removed lines',
    defaultMessage:
      '{count, plural, one {{count} line} other {{count} lines}} removed,',
  },

  addedFileType: {
    id: 'bitkit.fileTree.addedFileType',
    description: 'Text label for added file icon',
    defaultMessage: 'Added file',
  },

  deletedFileType: {
    id: 'bitkit.fileTree.deletedFileType',
    description: 'Text label for deleted file icon',
    defaultMessage: 'Deleted file',
  },

  modifiedFileType: {
    id: 'bitkit.fileTree.modifiedFileType',
    description: 'Text label for modified file icon',
    defaultMessage: 'Modified file',
  },

  typeChangedFileType: {
    id: 'bitkit.fileTree.typeChangedFileType',
    description: 'Text label for type change file icon',
    defaultMessage: 'File type changed',
  },

  renamedFileType: {
    id: 'bitkit.fileTree.renamedFileType',
    description: 'Text label for renamed file icon',
    defaultMessage: 'Renamed file',
  },

  directory: {
    id: 'bitkit.fileTree.directory',
    description: 'Text label for directory icon',
    defaultMessage: 'Directory',
  },

  toggleDirectory: {
    id: 'bitkit.fileTree.toggleDirectory',
    description: 'Text for the label for toggling directory',
    defaultMessage: 'Toggle directory',
  },

  conflicted: {
    id: 'bitkit.fileTree.conflictedLabel',
    description: 'Text for the label for a conflicted directory',
    defaultMessage: 'Conflicted',
  },
  hiddenTooltip: {
    id: 'bitkit.fileTree.hiddenTooltip',
    description: 'Text for the tooltip when a file is hidden due to filtering',
    defaultMessage: 'This file is hidden because of the filters you have set.',
  },
});
